export default "__VITE_ASSET__DdxmleGx__"